<template>
  <div class="star">
    <div class="yellow" :style="style"></div>
  </div>
</template>

<script>
export default {
  props: {
    precent: {
      type: Number,
      default: 0,
      required: true
    }
  },
  computed: {
    style() {
      return {
        width: `${this.precent}%`
      };
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/scss/libs.scss";
.star {
  display: inline-block;
  margin-left:px2rem(10);
  @include square(28);
  background: {
    image: url("~@/assets/images/index/star_gray.png");
    position: left center;
    size: 100% 100%;
    repeat: no-repeat;
  }
  .yellow {
    height: 100%;
    overflow: hidden;
    background: {
      image: url("~@/assets/images/index/star_yellow.png");
      position: left center;
      size: auto 100%;
      repeat: no-repeat;
    }
  }
}
// .starList {
//     @include dis-flex(center);
//     line-height: 1;
//     font-size: px2rem(28);
//     img {
//         display: block;
//         height: px2rem(36);
//         margin-right: px2rem(10);
//     }
//     span {
//         color: #a6a6a6;
//         margin-left: px2rem(60);
//     }
//     .yellow {
//         color: #f7cd0f;
//     }
//     .red {
//         color: #e32351;
//     }
// }
</style>
